interface ColumnNameConfig<T> {
  header: string;
  field: keyof T; 
  format?: (val: T[keyof T]) => string | number;
  csvFormat?: (val: T[keyof T]) => string; 
};

interface FlatTherapistData {
    locationId: string,
    lastName: string | undefined,
    firstName: string | undefined,
    value: number,
    auslastung: number,
    revenueProductivityHour: number,
    revenueScheduledHour: number,
    rxCount: number,
    gaps: number,
    gapsInHours: number,
}

export const therapistTableConfigs = {
    therapists: {
        columns: [
            { header: "Standort", field: "locationId" },
            { header: "Nachname", field: "lastName" },
            { header: "Vorname", field: "firstName" },
            { header: "Umsatz €", field: "value", format: (val: number) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(val), csvFormat: (val: number) => val.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2}) },
            { header: "Auslastung %", field: "auslastung", format: (val: number) => new Intl.NumberFormat("de-DE", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val), csvFormat: (val: number) => val.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2}) },
            { header: "Umsatz pro belegte Stunde", field: "revenueProductivityHour", format: (val: number) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(val), csvFormat: (val: number) => val.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2}) },
            { header: "Umsatz pro Arbeitsstunde", field: "revenueScheduledHour", format: (val: number) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(val), csvFormat: (val: number) => val.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2}) },
            { header: "Rx Anzahl", field: "rxCount" },
            { header: "Lücken", field: "gapsInHours", format: (val: number) => new Intl.NumberFormat("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(val), csvFormat: (val: number) => new Intl.NumberFormat("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(val) },
        ] as ColumnNameConfig<FlatTherapistData>[],
    }
}